import { SignInResponse } from '@models/auth';
import {
  SignUpRequest, UserAssetResponse, UserDetail, UserProfile,
} from '@models/user';

import instance from '../instance';

const baseUrl = '/user';

class UserApi {
  static signUp(request: SignUpRequest): Promise<SignInResponse> {
    return instance.post(`${baseUrl}/signup`, request);
  }

  static getUserProfile(): Promise<UserProfile> {
    return instance.get(baseUrl);
  }

  static getUserDetail(): Promise<UserDetail> {
    return instance.get('/user/details');
  }

  static getAssets(): Promise<UserAssetResponse> {
    return instance.get('/user/assets');
  }

  static updateNickname(nickname: string): Promise<unknown> {
    return instance.patch('/user/nickname', { nickname });
  }

  static toggleMarketingAgreement(): Promise<never> {
    return instance.put('/user/agreements/marketing');
  }

  static toggleLocationAgreement(status: boolean): Promise<never> {
    return instance.put('/user/agreements/location', { status });
  }
}

export default UserApi;
